<!-- Permissions -->
<div [appEnforcePermission]="authConfig.manageExpensePurposesCreate" #manageExpensePurposesCreate="appEnforcePermission"></div>
<div [appEnforcePermission]="authConfig.manageExpensePurposesUpdate" #manageExpensePurposesUpdate="appEnforcePermission"></div>
<div [appEnforcePermission]="authConfig.manageExpensePurposesDelete" #manageExpensePurposesDelete="appEnforcePermission"></div>
<div [appEnforcePermission]="authConfig.manageExpensePurposesDeactivate" #manageExpensePurposesDeactivate="appEnforcePermission"></div>
<!-- Permissions -->
<section>
  <kendo-gridlayout class="mt-16" [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat(1,minmax(0,1fr))']" *ngIf="manageExpensePurposesCreate?.enabled">
    <kendo-gridlayout-item class="text-right mb-0">
      <kendo-button class="mr-16" kendoButton themeColor="primary" iconClass="fa fa-plus" fillMode="solid" size="medium" (click)="add()">
        New Purpose
      </kendo-button>
    </kendo-gridlayout-item>
  </kendo-gridlayout>

  <kendo-grid
    class="expense-report-category-list mt-16"
    [data]="{
      data: data,
      total: (dataSource?.pageInfo$ | async)?.totalCount
    }"
    [pageSize]="pageOptions?.limit"
    [skip]="pageOptions?.offset"
    [pageable]="false"
    (pageChange)="pageOptions?.paginate($event);"
    [sortable]="true"
    [sort]="sort"
    (sortChange)="sortChange($event)"
    [navigatable]="false"
  >
    <kendo-grid-column
      field="NAME"
      title="Category"
      [width]="25"
      [sortable]="true"
      [headerClass]="'sort-header'"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <a
          *ngIf="manageExpensePurposesUpdate?.enabled else onlyName"
          (click)="edit(dataItem)"
          tel=""
          class="text-decoration"
          [ngClass]="{'text-line-through': !dataItem.active}"
        >
          {{ dataItem?.name }}
        </a>
        <ng-template #onlyName>
          <span [ngClass]="{'text-line-through': !dataItem.active}">{{dataItem.name}}</span>
        </ng-template>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="EXPENSE_TYPE"
      title="Type"
      [width]="40"
      [sortable]="false"
      [headerClass]="'nocursor'"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <span [ngClass]="{'text-line-through': !dataItem.active}" *ngFor="let p of dataItem.ExpenseCategories" class="appliesTo" [innerHTML]="p.name"></span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="id"
      title="Action"
      [width]="8"
      [sortable]="false"
      [headerClass]="'nocursor'"
      *ngIf="actionItem?.length"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-dropdownbutton
          [data]="getFilteredActionItems(dataItem)"
          themeColor="primary" fillMode="link" buttonClass="grid-action-items" iconClass="fa-solid fa-ellipsis"
          (itemClick)="itemSelected($event, dataItem)" 
          [popupSettings]="{
            appendTo: 'component',
            animate: false,
            width: 250,
            popupClass: 'grid-action-items-menu'
          }">
        </kendo-dropdownbutton>
      </ng-template>
    </kendo-grid-column>

    <!-- No record -->
    <ng-template kendoGridNoRecordsTemplate>
      <p class="mt-24 mb-24">There are no results to display.</p>
    </ng-template>
  </kendo-grid>
</section>